/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PaymentMethodsBankAccount,
  PaymentMethodsBankAccount$inboundSchema,
  PaymentMethodsBankAccount$Outbound,
  PaymentMethodsBankAccount$outboundSchema,
} from "./paymentmethodsbankaccount.js";

export type RtpCreditPaymentMethod = {
  /**
   * ID of the payment method.
   */
  paymentMethodID: string;
  paymentMethodType: "rtp-credit";
  /**
   * A bank account as contained within a payment method.
   */
  bankAccount: PaymentMethodsBankAccount;
};

/** @internal */
export const RtpCreditPaymentMethod$inboundSchema: z.ZodType<
  RtpCreditPaymentMethod,
  z.ZodTypeDef,
  unknown
> = z.object({
  paymentMethodID: z.string(),
  paymentMethodType: z.literal("rtp-credit"),
  bankAccount: PaymentMethodsBankAccount$inboundSchema,
});
/** @internal */
export type RtpCreditPaymentMethod$Outbound = {
  paymentMethodID: string;
  paymentMethodType: "rtp-credit";
  bankAccount: PaymentMethodsBankAccount$Outbound;
};

/** @internal */
export const RtpCreditPaymentMethod$outboundSchema: z.ZodType<
  RtpCreditPaymentMethod$Outbound,
  z.ZodTypeDef,
  RtpCreditPaymentMethod
> = z.object({
  paymentMethodID: z.string(),
  paymentMethodType: z.literal("rtp-credit"),
  bankAccount: PaymentMethodsBankAccount$outboundSchema,
});

export function rtpCreditPaymentMethodToJSON(
  rtpCreditPaymentMethod: RtpCreditPaymentMethod,
): string {
  return JSON.stringify(
    RtpCreditPaymentMethod$outboundSchema.parse(rtpCreditPaymentMethod),
  );
}
export function rtpCreditPaymentMethodFromJSON(
  jsonString: string,
): SafeParseResult<RtpCreditPaymentMethod, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RtpCreditPaymentMethod$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RtpCreditPaymentMethod' from JSON`,
  );
}
